module.exports = __webpack_public_path__ + "img/gear-F-high_74x74.cc52bfa1.png";